// import api from "service/api";
import { setTokenGlobal, setBaseURL, setTokenBase } from "service/common";
import { Cookies } from "react-cookie";
import configs from "constants/configs";
import CauHinhApi from "../service/cauHinhApi";
export function interceptor() {
  const cookies = new Cookies();
  var token = cookies.get("userInfo");
  if (typeof token != "undefined" && token.length > 6) {
    token = token.substring(6).replace(/"/g, "");
    var apilink = cookies.get("apilink");
    setTokenBase(token, window.endPoint);
  } else {
    const userName = cookies.get("userInfo1");
    if (!userName && !window.location.href.includes("two-factor")) {
      if (typeof window.mormanServer != "undefined") {
        window.location.href = window.mormanServer + "dang-nhap.aspx?Logout=1";
      } else {
        window.location.href = "https://hi.morman.vn/dang-nhap.aspx?Logout=1";
      }
    }
  }
}
